// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();





export const getImageServices = async(imageName:string, typeImage: string) => {
   
    try {
        
        
        return await http.getImages<any>(`/v1/files/${typeImage}/`+imageName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}




export const getMarcoServices = async(typeImage: string) => {
   
    try {
        
        
        return await http.getImages<any>(`/v1/files/marco-carnet/`+typeImage); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}


export const getPdfServices = async(pdfName:string) => {
   
    try {
        

        return await http.getImages<any>(`/v1/files/pdf-employee/`+pdfName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}






export const getPdfGlobalServices = async(typeUrl:string, pdfName:string) => {
   
    try {
        
        return await http.getImages<any>(`/v1/files/pdf-viewer/${typeUrl}/${pdfName}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}



export const getPdfBeneficiaryServices = async(pdfName:string) => {
   
    try {
        

        return await http.getImages<any>(`/v1/files/pdf-employee-beneficiary/`+pdfName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}



export const getImageServices2 = async(imageName:string) => {
   
    try {
        
     
        return await http.getImages<any>(`/v1/files/company/`+imageName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
       

    }
}
